import React, { Component } from 'react';
import { Redirect } from 'react-router';

import '../styles/SearchBar.css';

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this._updateDimensions = this._updateDimensions.bind(this);
        this.state = { query: null, redirect: false, placeholder: this._getPlaceholder() };
    }

    _input(event) {
        this.setState({ query: event.target.value });
    }

    _search(event) {
        if (this.state.query && this.state.query.trim())
            this.setState({redirect: true});
    }

    _enter(event) {
        if (event.key === 'Enter') this._search();
    }

    _getPlaceholder() {
        let mq = window.matchMedia("(max-width: 480px)");
        return (mq.matches) ? '' : "Search for a course, instructor or department";
    }

    _updateDimensions() {
        let _placeholder = this._getPlaceholder();
        if (_placeholder !== this.state.placeholder)
            this.setState({ placeholder: _placeholder});
    }

    componentDidMount() {
        window.addEventListener("resize", this._updateDimensions);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={{ pathname: '/search/' + this.state.query.trim(),
                state: { query: this.state.query.trim() }}} />
        }
        return (
            <div className="search-bar">
                <div className="search-bar-name">UW-Madison Grade Distribution Search</div>
                <input id="search-input" placeholder={ this.state.placeholder }
                       type="text" onChange={ this._input.bind(this) } onKeyPress={ this._enter.bind(this) } />
                <input id="search-button" name="Search" value="Search" type="button"
                       onClick={ this._search.bind(this) } />
            </div>
        );
    }

    componentDidUpdate() {
        if (this.state.redirect)
            this.setState({ redirect: false });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._updateDimensions);
    }
}

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/SearchBar.js